const locale = {
  'JsonView.label': 'JSON Viewer',
  'JsonView.searchPlaceholder': 'Search...',
  'JsonView.expand': 'Expand',
  'JsonView.collapse': 'Collapse',
  'JsonView.expandAll': 'Expand All',
  'JsonView.collapseAll': 'Collapse All',
  'JsonView.items': 'items',
  'JsonView.keys': 'keys',
  'JsonView.copy': 'Copy',
  'JsonView.copied': 'Copied'
};

export default locale;
